export const testSQ = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize;
out vec4 final;

float map(float value, float min1, float max1, float min2, float max2) {
    return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
    }

float rectshape(vec2 position,vec2 scale){
   scale=vec2(.5)-scale*.5;
   vec2 shaper=vec2(step(scale.x,position.x),step(scale.y,position.y));
   shaper*=vec2(step(scale.x,1.-position.x),step(scale.y,1.-position.y));
   return shaper.x*shaper.y;}
   
void main(){

   vec3 c1 = vec3(u_siize, 0.8353*sin(u_time*0.00015), 0.9333);
vec3 c2 = vec3(0.8941, 0.102, 0.0588);
vec3 c22 = vec3(0.0549, 0.298*sin(u_time*0.00015), 0.9098);
vec3 c3 = vec3(0.0471, 0.0039+u_siize, 0.0392);
float delta = sin(u_time*0.00015)+1.0/2.;
float h0 = .75;
float h = .15;
float h2 = map(u_siize, 0.0, 1.0, 0.05, 0.1);
float h3 = map(u_siize, 0.0, 1.0, 0.01, 1.0);

   vec2 position=gl_FragCoord.xy/u_resolution;
   vec2 translate = vec2(0.1*sin(u_time*0.00015),0.1*cos(u_time*0.00015));
   
   // position += translate;
   vec3 color=vec3(1.0, 1.0, 1.0);
   // vec3 colorForRectTwo=vec3(0.9, 0.9, 0.9);
   vec3 colorForRectTwo=mix(vec3(0.9, 0.33, 0.45), vec3(0.65,0.33,0.17), position.y * sin(u_time*0.0005));
   vec3 color2=c22;
   float rectangle=rectshape(position  ,vec2(h2,h2));
   float rectangleTwo=rectshape(position ,vec2(h2,h2));
   
   vec3 cmix = mix(c1,c22,delta);
   vec3 cmixA = mix(c2,c1,delta);
vec3 cmix0 = mix(cmix,cmixA,(position.x-h*delta)/(1.-h));






vec3 col=mix(       mix(c3,cmix0,position.y/h0),
                    mix(cmix0,c1,(position.y-h0)/(1.-h0)),                
                    step(h0,position.y)
                    );

                  

//    color=color*(rectangle);
  // color2=color2*color;
    
  
   
   if (rectangleTwo > 0.0) {
       color2 = c1;
   }
//    if (rectangle > 0.0) {
//       color2 = c3;
//   }
   final=vec4(color2,1.);
}`